import { createAction } from '@src/redux/helpers/createAction';
import { SET_DENTAL } from './constants';

export const setDental = (payload) => {
  return createAction({
    type: SET_DENTAL,
    payload,
  });
};
